import { AnalyticsAction } from '@superbet-group/web.types';

let registrationType = AnalyticsAction.Classic as string;

export function getRegistrationType(): string {
    return registrationType;
}

export function setRegistrationType(value: string): void {
    registrationType = value;
}
